import React, { useEffect, useMemo, useState } from 'react';
import Text from '../../components/Text';
import Paper from '../../components/Paper';
import { createUseStyles } from 'react-jss';
import {FLAVOUR,vatRate,currencyName} from '../../config/serverInfo'; 
export interface PaymentBreakdownProps {
  discount: number,
  paymentCost: number,
  deliveryCost: number;
  orders: Record<
    string,
    {
      itemsCost: number;
      itemsCount: number;
      deliveryCost: number;
    }
  >;
}

const PaymentBreakdown: React.FC<PaymentBreakdownProps> = ({ orders, paymentCost, discount, deliveryCost }) => {
  const classes = useStyles();
  const [subtotal, setSubtotal] = useState(0);
  const [deliveryFee, setDeliveryFee] = useState(deliveryCost);
  const totalPrice = useMemo(() => {
    let price = 0;
    let tempDeliveryFee = deliveryCost;
    Object.keys(orders).forEach((key) => {
      price += orders[key].itemsCost
    });
    setSubtotal(price)
    // if (price >= 200) {
    //   setDeliveryFee(0)
    //   tempDeliveryFee = 0;
    // }

    return price + tempDeliveryFee + paymentCost - discount;
  }, [orders]);

 
  useEffect(() => {
     
  }, []);
  const vat = ((totalPrice * vatRate) / 100).toFixed(2);
  const grand = parseFloat(totalPrice as any) + parseFloat(vat);
  return (
    <Paper withShadow={false} className="p-3">
      <Text className="mb-3" as="h5" bold>
        Payment breakdown
      </Text>

    {/* USD TASK */}
      {Object.keys(orders).map((key) => (
        <div key={key}>
          <div className={classes.suborder}>
            <Text className="m-0">
              Sub Total ({orders[key].itemsCount} items)
            </Text>
            <Text className="m-0" bold>
              {(orders[key].itemsCost).toFixed(2)} {currencyName}
            </Text>
          </div>
        </div>
      ))}

      <div className={classes.suborder}>
        <Text className="m-0">Discount</Text>
        <Text className="m-0" bold>{(discount).toFixed(2)} {currencyName}</Text>
      </div>
      <div className={classes.suborder}>
        <Text className="m-0">Net Total</Text>
        <Text className="m-0" bold>{(subtotal - discount).toFixed(2)} {currencyName}</Text>
      </div>

      <div className={classes.suborder}>
        <Text className="m-0">Payment Fee</Text>
        <Text className="m-0" bold>{(paymentCost).toFixed(2)} {currencyName}</Text>
      </div>

      <div className={classes.suborder}>
        <Text className="m-0">Delivery Fee</Text>
        <Text className="m-0" bold>{(deliveryFee).toFixed(2)} {currencyName}</Text>
      </div>


      <div className={classes.suborder}>
        <Text className="m-0">Grand Total</Text>
        <Text className="m-0" bold>{(totalPrice).toFixed(2)} {currencyName}</Text>
      </div>

      {FLAVOUR=='US' ? (
        <>
        <div className={classes.suborder}>
        <Text className="m-0">Sales Tax</Text>
        <Text className="m-0" bold>Included</Text>
        </div>

      <hr />
      <div className={classes.suborder}>
        <Text className="m-0">Grand total(Tax included)</Text>
        <Text className="m-0" bold>{(grand).toFixed(2)} {currencyName}</Text>
      </div>
      </>
      ) :(
        <>
        <div className={classes.suborder}>
        <Text className="m-0">VAT ({vatRate + "%"})</Text>
        <Text className="m-0" bold>{vat} {currencyName}</Text>
      </div>

      <hr />
      <div className={classes.suborder}>
        <Text className="m-0">Grand total with VAT</Text>
        <Text className="m-0" bold>{(grand).toFixed(2)} {currencyName}</Text>
      </div>
      </>
      )}

    </Paper>
  );
};

const useStyles = createUseStyles({
  suborder: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1rem',
  },
});

export default PaymentBreakdown;
